import { useDispatch, useSelector } from 'react-redux';
import TextareaAutosize from 'react-textarea-autosize';
import { updateStart, updatePassengers, updateNotes, updatePromo, updateFullname, updateCompany, updateEmail, updatePhone } from '../../store/inquerySlice';
import { useState } from 'react';


function DetailsScreen(props) {
    const dispatch = useDispatch();

    const [ forCompany, setForCompany ] = useState(false);

    const waypoints = useSelector((state) => state.inquery.waypoints);
    const passengers = useSelector((state) => state.inquery.passengers);
    const notes = useSelector((state) => state.inquery.notes);
    const promo = useSelector((state) => state.inquery.promo);

    const fullname = useSelector((state) => state.inquery.fullname);
    const company = useSelector((state) => state.inquery.company);
    const email = useSelector((state) => state.inquery.email);
    const phone = useSelector((state) => state.inquery.phone);

    return (
        <form className="section" id="inquery-required-check" onSubmit={(e) => e.preventDefault()} >
            <div className="column g16 top">
                <p className="title">REISIJAD</p>
                <p>Reisijate ja tellija andmed</p>
            </div>
            <div className="column g16 p32">

                <div className="column g4">
                    <b>REISIJAID</b>
                    <input type="number" min={1} placeholder='25' value={passengers} onChange={(e) => dispatch(updatePassengers({ passengers: e.target.value }))} required />
                </div>

                <div className="column g4">
                    <b>LISAINFO</b>
                    <TextareaAutosize style={{ resize: 'none' }} minRows={3} value={notes} onChange={(e) => dispatch(updateNotes({ notes: e.target.value }))} />
                </div>

                <div className="column g4">
                    <b>SOODUSKOOD</b>
                    <input type="text" name="promo" id="promo" value={promo} onChange={(e) => dispatch(updatePromo({promo: e.target.value}))} />
                </div>

            </div>
            <hr />
            <div className="column g16 p32">

                <div className="column g4">
                    <b>NIMI</b>
                    <input type="text" name="fullname" id="fullname" value={fullname} onChange={(e) => dispatch(updateFullname({fullname: e.target.value}))} required />
                </div>

                <div className="column g4">
                    <b>ETTEVÕTTELE</b>

                    <div className="row g8">
                        <input type="checkbox" id='forCompany' onChange={(e) => setForCompany(e.target.checked)} value={forCompany} />
                        <label for='forCompany'>Arve esitada ettevõttele</label>
                    </div>
                </div>

                { forCompany && (
                    <div className="column g4">
                        <b>ETTEVÕTE NIMI</b>
                        <input type="text" name="company" id="company" value={company} onChange={(e) => dispatch(updateCompany({company: e.target.value}))} />
                    </div>
                ) }

                <div className="column g4">
                    <b>E-POST</b>
                    <input type="email" name="email" id="email" value={email} onChange={(e) => dispatch(updateEmail({email: e.target.value }))} required />
                </div>

                <div className="column g4">
                    <b>TELEFON</b>
                    <input type="text" name="phone" id="phone" value={phone} onChange={(e) => dispatch(updatePhone({phone: e.target.value }))} required />
                </div>
            </div>
        </form>
    )
};

export default DetailsScreen;